import { PayloadAction } from '@reduxjs/toolkit';

import { ReportsState } from '../../types';

export const setUnauthReportStatusResponse = (
  state: ReportsState,
  action: PayloadAction<number | null>,
) => {
  state.unauthorizedReport.responseStatusNumber = action.payload;
};
